const Countries = [
  {
    name: 'Afghanistan',
    code: 'AF',
    dialCode: '+93',
    mask: '999 999 9999'
  },
  {
    name: 'Åland Islands',
    code: 'AX',
    dialCode: '+358',
    mask: '999 9999999'
  },
  {
    name: 'Albania',
    code: 'AL',
    dialCode: '+355',
    mask: '999 999 9999'
  },
  {
    name: 'Algeria',
    code: 'DZ',
    dialCode: '+213',
    mask: '9999 99 99 99'
  },
  {
    name: 'American Samoa',
    code: 'AS',
    dialCode: '+1684',
    mask: '(999) 999-9999'
  },
  {
    name: 'Andorra',
    code: 'AD',
    dialCode: '+376',
    mask: '999 999'
  },
  {
    name: 'Angola',
    code: 'AO',
    dialCode: '+244',
    mask: '999 999 999'
  },
  {
    name: 'Anguilla',
    code: 'AI',
    dialCode: '+1264',
    mask: '(999) 999-9999'
  },
  {
    name: 'Antigua and Barbuda',
    code: 'AG',
    dialCode: '+1268',
    mask: '(999) 999-9999'
  },
  {
    name: 'Argentina',
    code: 'AR',
    dialCode: '+54',
    mask: '999 99-9999-9999'
  },
  {
    name: 'Armenia',
    code: 'AM',
    dialCode: '+374',
    mask: '999 999999'
  },
  {
    name: 'Aruba',
    code: 'AW',
    dialCode: '+297',
    mask: '999 9999'
  },
  {
    name: 'Australia',
    code: 'AU',
    dialCode: '+61',
    mask: '9999 999 999'
  },
  {
    name: 'Austria',
    code: 'AT',
    dialCode: '+43',
    mask: '9999 999999'
  },
  {
    name: 'Azerbaijan',
    code: 'AZ',
    dialCode: '+994',
    mask: '999 999 99 99'
  },
  {
    name: 'Bahamas',
    code: 'BS',
    dialCode: '+1242',
    mask: '(999) 999-999'
  },
  {
    name: 'Bahrain',
    code: 'BH',
    dialCode: '+973',
    mask: '9999 9999'
  },
  {
    name: 'Bangladesh',
    code: 'BD',
    dialCode: '+880',
    mask: '99999-999999'
  },
  {
    name: 'Barbados',
    code: 'BB',
    dialCode: '+1246',
    mask: '(999) 999-9999'
  },
  {
    name: 'Belarus',
    code: 'BY',
    dialCode: '+375',
    mask: '9 999 999-99-99'
  },
  {
    name: 'Belgium',
    code: 'BE',
    dialCode: '+32',
    mask: '9999 99 99 99'
  },
  {
    name: 'Belize',
    code: 'BZ',
    dialCode: '+501',
    mask: '999-9999'
  },
  {
    name: 'Benin',
    code: 'BJ',
    dialCode: '+229',
    mask: '99 99 99 99'
  },
  {
    name: 'Bermuda',
    code: 'BM',
    dialCode: '+1441',
    mask: '(999) 999-9999'
  },
  {
    name: 'Bhutan',
    code: 'BT',
    dialCode: '+975',
    mask: '99 99 99 99'
  },
  {
    name: 'Bolivia, Plurinational State of bolivia',
    code: 'BO',
    dialCode: '+591',
    mask: '99999999'
  },
  {
    name: 'Bosnia and Herzegovina',
    code: 'BA',
    dialCode: '+387',
    mask: '999 999 999'
  },
  {
    name: 'Botswana',
    code: 'BW',
    dialCode: '+267',
    mask: '99 999 999'
  },
  {
    name: 'Bouvet Island',
    code: 'BV',
    dialCode: '+47',
    mask: '(99) 99999-9999'
  },
  {
    name: 'Brazil',
    code: 'BR',
    dialCode: '+55',
    mask: '999 9999'
  },
  {
    name: 'British Indian Ocean Territory',
    code: 'IO',
    dialCode: '+246',
    mask: '(999) 999-9999'
  },
  {
    name: 'Brunei Darussalam',
    code: 'BN',
    dialCode: '+673',
    mask: '999 9999'
  },
  {
    name: 'Bulgaria',
    code: 'BG',
    dialCode: '+359',
    mask: '999 999 999'
  },
  {
    name: 'Burkina Faso',
    code: 'BF',
    dialCode: '+226',
    mask: '99 99 99 99'
  },
  {
    name: 'Burundi',
    code: 'BI',
    dialCode: '+257',
    mask: '99 99 99 99'
  },
  {
    name: 'Cambodia',
    code: 'KH',
    dialCode: '+855',
    mask: '999 999 999'
  },
  {
    name: 'Cameroon',
    code: 'CM',
    dialCode: '+237',
    mask: '9 99 99 99 99'
  },
  {
    name: 'Canada',
    code: 'CA',
    dialCode: '+1',
    mask: '(999) 999-9999'
  },
  {
    name: 'Cape Verde',
    code: 'CV',
    dialCode: '+238',
    mask: '999 99 99'
  },
  {
    name: 'Cayman Islands',
    code: 'KY',
    dialCode: '+345',
    mask: '999 9999'
  },
  {
    name: 'Central African Republic',
    code: 'CF',
    dialCode: '+236',
    mask: '99 99 99 99'
  },
  {
    name: 'Chad',
    code: 'TD',
    dialCode: '+235',
    mask: '99 99 99 99'
  },
  {
    name: 'Chile',
    code: 'CL',
    dialCode: '+56',
    mask: '(9) 9999 9999'
  },
  {
    name: 'China',
    code: 'CN',
    dialCode: '+86',
    mask: '999 9999 9999'
  },
  {
    name: 'Christmas Island',
    code: 'CX',
    dialCode: '+61',
    mask: '9999 999 999'
  },
  {
    name: 'Cocos (Keeling) Islands',
    code: 'CC',
    dialCode: '+61',
    mask: '9999 999 999'
  },
  {
    name: 'Colombia',
    code: 'CO',
    dialCode: '+57',
    mask: '999 9999999'
  },
  {
    name: 'Comoros',
    code: 'KM',
    dialCode: '+269',
    mask: '999 99 99'
  },
  {
    name: 'Congo',
    code: 'CG',
    dialCode: '+242',
    mask: '9999 999 999'
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    code: 'CD',
    dialCode: '+243',
    mask: '99 999 9999'
  },
  {
    name: 'Cook Islands',
    code: 'CK',
    dialCode: '+682',
    mask: '99 999'
  },
  {
    name: 'Costa Rica',
    code: 'CR',
    dialCode: '+506',
    mask: '9999 9999'
  },
  {
    name: "Cote d'Ivoire",
    code: 'CI',
    dialCode: '+225',
    mask: '99 99 99 99'
  },
  {
    name: 'Croatia',
    code: 'HR',
    dialCode: '+385',
    mask: '999 999 9999'
  },
  {
    name: 'Cuba',
    code: 'CU',
    dialCode: '+53',
    mask: '99 9999999'
  },
  {
    name: 'Cyprus',
    code: 'CY',
    dialCode: '+357',
    mask: '99 999999'
  },
  {
    name: 'Czech Republic',
    code: 'CZ',
    dialCode: '+420',
    mask: '999 999 999'
  },
  {
    name: 'Denmark',
    code: 'DK',
    dialCode: '+45',
    mask: '99 99 99 99'
  },
  {
    name: 'Djibouti',
    code: 'DJ',
    dialCode: '+253',
    mask: '99 99 99 99'
  },
  {
    name: 'Dominica',
    code: 'DM',
    dialCode: '+1767',
    mask: '(999) 999-9999'
  },
  {
    name: 'Ecuador',
    code: 'EC',
    dialCode: '+593',
    mask: '999 999 9999'
  },
  {
    name: 'Egypt',
    code: 'EG',
    dialCode: '+20',
    mask: '9999 999 9999'
  },
  {
    name: 'El Salvador',
    code: 'SV',
    dialCode: '+503',
    mask: '9999 9999'
  },
  {
    name: 'Equatorial Guinea',
    code: 'GQ',
    dialCode: '+240',
    mask: '999 999 999'
  },
  {
    name: 'Eritrea',
    code: 'ER',
    dialCode: '+291',
    mask: '99 999 999'
  },
  {
    name: 'Estonia',
    code: 'EE',
    dialCode: '+372',
    mask: '9999 9999'
  },
  {
    name: 'Ethiopia',
    code: 'ET',
    dialCode: '+251',
    mask: '999 999 9999'
  },
  {
    name: 'Falkland Islands (Malvinas)',
    code: 'FK',
    dialCode: '+500',
    mask: '99999'
  },
  {
    name: 'Faroe Islands',
    code: 'FO',
    dialCode: '+298',
    mask: '999999'
  },
  {
    name: 'Fiji',
    code: 'FJ',
    dialCode: '+679',
    mask: '999 9999'
  },
  {
    name: 'Finland',
    code: 'FI',
    dialCode: '+358',
    mask: '999 9999999'
  },
  {
    name: 'France',
    code: 'FR',
    dialCode: '+33',
    mask: '99 99 99 99 99'
  },
  {
    name: 'French Guiana',
    code: 'GF',
    dialCode: '+594',
    mask: '9999 99 99 99'
  },
  {
    name: 'French Polynesia',
    code: 'PF',
    dialCode: '+689',
    mask: '99 99 99 99'
  },
  {
    name: 'Gabon',
    code: 'GA',
    dialCode: '+241',
    mask: '99 99 99 99'
  },
  {
    name: 'Gambia',
    code: 'GM',
    dialCode: '+220',
    mask: '999 9999'
  },
  {
    name: 'Georgia',
    code: 'GE',
    dialCode: '+995',
    mask: '999 99 99 99'
  },
  {
    name: 'Germany',
    code: 'DE',
    dialCode: '+49',
    mask: '99999 9999999'
  },
  {
    name: 'Ghana',
    code: 'GH',
    dialCode: '+233',
    mask: '999 999 9999'
  },
  {
    name: 'Gibraltar',
    code: 'GI',
    dialCode: '+350',
    mask: '99999999'
  },
  {
    name: 'Greece',
    code: 'GR',
    dialCode: '+30',
    mask: '999 999 9999'
  },
  {
    name: 'Greenland',
    code: 'GL',
    dialCode: '+299',
    mask: '99 99 99'
  },
  {
    name: 'Grenada',
    code: 'GD',
    dialCode: '+1473',
    mask: '(999) 999-9999'
  },
  {
    name: 'Guadeloupe',
    code: 'GP',
    dialCode: '+590',
    mask: '9999 99 99 99'
  },
  {
    name: 'Guam',
    code: 'GU',
    dialCode: '+1671',
    mask: '(999) 999-9999'
  },
  {
    name: 'Guatemala',
    code: 'GT',
    dialCode: '+502',
    mask: '9999 9999'
  },
  {
    name: 'Guernsey',
    code: 'GG',
    dialCode: '+44',
    mask: '99999 999999'
  },
  {
    name: 'Guinea',
    code: 'GN',
    dialCode: '+224',
    mask: '999 99 99 99'
  },
  {
    name: 'Guinea-Bissau',
    code: 'GW',
    dialCode: '+245',
    mask: '999 999 999'
  },
  {
    name: 'Guyana',
    code: 'GY',
    dialCode: '+592',
    mask: '999 9999'
  },
  {
    name: 'Haiti',
    code: 'HT',
    dialCode: '+509',
    mask: '99 99 9999'
  },
  {
    name: 'Honduras',
    code: 'HN',
    dialCode: '+504',
    mask: '9999-9999'
  },
  {
    name: 'Hong Kong',
    code: 'HK',
    dialCode: '+852',
    mask: '9999 9999'
  },
  {
    name: 'Hungary',
    code: 'HU',
    dialCode: '+36',
    mask: '(99) 999 9999'
  },
  {
    name: 'Iceland',
    code: 'IS',
    dialCode: '+354',
    mask: '999 9999'
  },
  {
    name: 'India',
    code: 'IN',
    dialCode: '+91',
    mask: '999999 99999'
  },
  {
    name: 'Indonesia',
    code: 'ID',
    dialCode: '+62',
    mask: '9999-999-999'
  },
  {
    name: 'Iran, Islamic Republic of Persian Gulf',
    code: 'IR',
    dialCode: '+98',
    mask: '9999 999 9999'
  },
  {
    name: 'Iraq',
    code: 'IQ',
    dialCode: '+964',
    mask: '9999 999 9999'
  },
  {
    name: 'Ireland',
    code: 'IE',
    dialCode: '+353',
    mask: '999 999 9999'
  },
  {
    name: 'Isle of Man',
    code: 'IM',
    dialCode: '+44',
    mask: '99999 999999'
  },
  {
    name: 'Israel',
    code: 'IL',
    dialCode: '+972',
    mask: '999-999-9999'
  },
  {
    name: 'Italy',
    code: 'IT',
    dialCode: '+39',
    mask: '999 999 9999'
  },
  {
    name: 'Jamaica',
    code: 'JM',
    dialCode: '+1876',
    mask: '(999) 999-9999'
  },
  {
    name: 'Japan',
    code: 'JP',
    dialCode: '+81',
    mask: '999-9999-9999'
  },
  {
    name: 'Jersey',
    code: 'JE',
    dialCode: '+44',
    mask: '99999 999999'
  },
  {
    name: 'Jordan',
    code: 'JO',
    dialCode: '+962',
    mask: '99 9999 9999'
  },
  {
    name: 'Kazakhstan',
    code: 'KZ',
    dialCode: '+7',
    mask: '9 (999) 999 9999'
  },
  {
    name: 'Kenya',
    code: 'KE',
    dialCode: '+254',
    mask: '9999 999999'
  },
  {
    name: 'Kiribati',
    code: 'KI',
    dialCode: '+686',
    mask: '99999999'
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    code: 'KP',
    dialCode: '+850',
    mask: '(9) 99999'
  },
  {
    name: 'Korea, Republic of South Korea',
    code: 'KR',
    dialCode: '+82',
    mask: '999-9999-9999'
  },
  {
    name: 'Kosovo',
    code: 'XK',
    dialCode: '+383',
    mask: '999 999 999'
  },
  {
    name: 'Kuwait',
    code: 'KW',
    dialCode: '+965',
    mask: '999 99999'
  },
  {
    name: 'Kyrgyzstan',
    code: 'KG',
    dialCode: '+996',
    mask: '9999 999 999'
  },
  {
    name: 'Laos',
    code: 'LA',
    dialCode: '+856',
    mask: '999 99 999 999'
  },
  {
    name: 'Latvia',
    code: 'LV',
    dialCode: '+371',
    mask: '99 999 999'
  },
  {
    name: 'Lebanon',
    code: 'LB',
    dialCode: '+961',
    mask: '99 999 999'
  },
  {
    name: 'Lesotho',
    code: 'LS',
    dialCode: '+266',
    mask: '9999 9999'
  },
  {
    name: 'Liberia',
    code: 'LR',
    dialCode: '+231',
    mask: '999 999 9999'
  },
  {
    name: 'Libyan Arab Jamahiriya',
    code: 'LY',
    dialCode: '+218',
    mask: '999-9999999'
  },
  {
    name: 'Liechtenstein',
    code: 'LI',
    dialCode: '+423',
    mask: '999 999 999'
  },
  {
    name: 'Lithuania',
    code: 'LT',
    dialCode: '+370',
    mask: '(9-999) 99999'
  },
  {
    name: 'Luxembourg',
    code: 'LU',
    dialCode: '+352',
    mask: '999 999 999'
  },
  {
    name: 'Macao',
    code: 'MO',
    dialCode: '+853',
    mask: '9999 9999'
  },
  {
    name: 'Macedonia',
    code: 'MK',
    dialCode: '+389',
    mask: '999 999 999'
  },
  {
    name: 'Madagascar',
    code: 'MG',
    dialCode: '+261',
    mask: '999 99 999 99'
  },
  {
    name: 'Malawi',
    code: 'MW',
    dialCode: '+265',
    mask: '9999 99 99 99'
  },
  {
    name: 'Malaysia',
    code: 'MY',
    dialCode: '+60',
    mask: '999-999 9999'
  },
  {
    name: 'Maldives',
    code: 'MV',
    dialCode: '+960',
    mask: '999-9999'
  },
  {
    name: 'Mali',
    code: 'ML',
    dialCode: '+223',
    mask: '99 99 99 99'
  },
  {
    name: 'Malta',
    code: 'MT',
    dialCode: '+356',
    mask: '9999 9999'
  },
  {
    name: 'Marshall Islands',
    code: 'MH',
    dialCode: '+692',
    mask: '999-9999'
  },
  {
    name: 'Martinique',
    code: 'MQ',
    dialCode: '+596',
    mask: '9999 99 99 99'
  },
  {
    name: 'Mauritania',
    code: 'MR',
    dialCode: '+222',
    mask: '99 99 99 99'
  },
  {
    name: 'Mauritius',
    code: 'MU',
    dialCode: '+230',
    mask: '9999 9999'
  },
  {
    name: 'Mayotte',
    code: 'YT',
    dialCode: '+262',
    mask: '9999 99 99 99'
  },
  {
    name: 'Mexico',
    code: 'MX',
    dialCode: '+52',
    mask: '999 999 999 9999'
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    code: 'FM',
    dialCode: '+691',
    mask: '999 9999'
  },
  {
    name: 'Moldova',
    code: 'MD',
    dialCode: '+373',
    mask: '9999 99 999'
  },
  {
    name: 'Monaco',
    code: 'MC',
    dialCode: '+377',
    mask: '99 99 99 99 99'
  },
  {
    name: 'Mongolia',
    code: 'MN',
    dialCode: '+976',
    mask: '9999 9999'
  },
  {
    name: 'Montenegro',
    code: 'ME',
    dialCode: '+382',
    mask: '999 999 999'
  },
  {
    name: 'Montserrat',
    code: 'MS',
    dialCode: '+1664',
    mask: '(999) 999-9999'
  },
  {
    name: 'Morocco',
    code: 'MA',
    dialCode: '+212',
    mask: '9999-999999'
  },
  {
    name: 'Mozambique',
    code: 'MZ',
    dialCode: '+258',
    mask: '99 999 9999'
  },
  {
    name: 'Myanmar',
    code: 'MM',
    dialCode: '+95',
    mask: '99 999 9999'
  },
  {
    name: 'Namibia',
    code: 'NA',
    dialCode: '+264',
    mask: '999 999 99999'
  },
  {
    name: 'Nauru',
    code: 'NR',
    dialCode: '+674',
    mask: '999 9999'
  },
  {
    name: 'Nepal',
    code: 'NP',
    dialCode: '+977',
    mask: '999-9999999'
  },
  {
    name: 'Netherlands',
    code: 'NL',
    dialCode: '+31',
    mask: '99'
  },
  {
    name: 'New Caledonia',
    code: 'NC',
    dialCode: '+687',
    mask: '99.99.99'
  },
  {
    name: 'New Zealand',
    code: 'NZ',
    dialCode: '+64',
    mask: '999 999 9999'
  },
  {
    name: 'Nicaragua',
    code: 'NI',
    dialCode: '+505',
    mask: '9999 9999'
  },
  {
    name: 'Niger',
    code: 'NE',
    dialCode: '+227',
    mask: '99 99 99 99'
  },
  {
    name: 'Nigeria',
    code: 'NG',
    dialCode: '+234',
    mask: '9999 999 9999'
  },
  {
    name: 'Niue',
    code: 'NU',
    dialCode: '+683',
    mask: '999 9999'
  },
  {
    name: 'Norfolk Island',
    code: 'NF',
    dialCode: '+672',
    mask: '9 99999'
  },
  {
    name: 'Northern Mariana Islands',
    code: 'MP',
    dialCode: '+1670',
    mask: '(999) 999-9999'
  },
  {
    name: 'Norway',
    code: 'NO',
    dialCode: '+47',
    mask: '999 99 999'
  },
  {
    name: 'Oman',
    code: 'OM',
    dialCode: '+968',
    mask: '9999 9999'
  },
  {
    name: 'Pakistan',
    code: 'PK',
    dialCode: '+92',
    mask: '9999 9999999'
  },
  {
    name: 'Palau',
    code: 'PW',
    dialCode: '+680',
    mask: '999 9999'
  },
  {
    name: 'Palestinian Territory, Occupied',
    code: 'PS',
    dialCode: '+970',
    mask: '9999 999 999'
  },
  {
    name: 'Panama',
    code: 'PA',
    dialCode: '+507',
    mask: '9999-9999'
  },
  {
    name: 'Papua New Guinea',
    code: 'PG',
    dialCode: '+675',
    mask: '9999 9999'
  },
  {
    name: 'Paraguay',
    code: 'PY',
    dialCode: '+595',
    mask: '9999 999999'
  },
  {
    name: 'Peru',
    code: 'PE',
    dialCode: '+51',
    mask: '999 999 999'
  },
  {
    name: 'Philippines',
    code: 'PH',
    dialCode: '+63',
    mask: '9999 999 9999'
  },
  {
    name: 'Poland',
    code: 'PL',
    dialCode: '+48',
    mask: '999 999 999'
  },
  {
    name: 'Portugal',
    code: 'PT',
    dialCode: '+351',
    mask: '999 999 999'
  },
  {
    name: 'Puerto Rico',
    code: 'PR',
    dialCode: '+1939',
    mask: '(999) 999-9999'
  },
  {
    name: 'Qatar',
    code: 'QA',
    dialCode: '+974',
    mask: '9999 9999'
  },
  {
    name: 'Romania',
    code: 'RO',
    dialCode: '+40',
    mask: '9999 999 999'
  },
  {
    name: 'Russia',
    code: 'RU',
    dialCode: '+7',
    mask: '9 (999) 999-99-99'
  },
  {
    name: 'Rwanda',
    code: 'RW',
    dialCode: '+250',
    mask: '9999 999 999'
  },
  {
    name: 'Saint Barthelemy',
    code: 'BL',
    dialCode: '+590',
    mask: '9999 99 99 99'
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    code: 'SH',
    dialCode: '+290',
    mask: '99999'
  },
  {
    name: 'Saint Kitts and Nevis',
    code: 'KN',
    dialCode: '+1869',
    mask: '(999) 999-9999'
  },
  {
    name: 'Saint Lucia',
    code: 'LC',
    dialCode: '+1758',
    mask: '(999) 999-9999'
  },
  {
    name: 'Saint Martin',
    code: 'MF',
    dialCode: '+590',
    mask: '9999 99 99 99'
  },
  {
    name: 'Saint Pierre and Miquelon',
    code: 'PM',
    dialCode: '+508',
    mask: '999 99 99'
  },
  {
    name: 'Saint Vincent and the Grenadines',
    code: 'VC',
    dialCode: '+1784',
    mask: '(999) 999-9999'
  },
  {
    name: 'Samoa',
    code: 'WS',
    dialCode: '+685',
    mask: '99 99999'
  },
  {
    name: 'San Marino',
    code: 'SM',
    dialCode: '+378',
    mask: '99 99 99 99'
  },
  {
    name: 'Sao Tome and Principe',
    code: 'ST',
    dialCode: '+239',
    mask: '999 9999'
  },
  {
    name: 'Saudi Arabia',
    code: 'SA',
    dialCode: '+966',
    mask: '999 999 9999'
  },
  {
    name: 'Senegal',
    code: 'SN',
    dialCode: '+221',
    mask: '99 999 99 99'
  },
  {
    name: 'Serbia',
    code: 'RS',
    dialCode: '+381',
    mask: '999 9999999'
  },
  {
    name: 'Seychelles',
    code: 'SC',
    dialCode: '+248',
    mask: '9 999 999'
  },
  {
    name: 'Sierra Leone',
    code: 'SL',
    dialCode: '+232',
    mask: '(999) 999999'
  },
  {
    name: 'Singapore',
    code: 'SG',
    dialCode: '+65',
    mask: '9999 9999'
  },
  {
    name: 'Slovakia',
    code: 'SK',
    dialCode: '+421',
    mask: '9999 999 999'
  },
  {
    name: 'Slovenia',
    code: 'SI',
    dialCode: '+386',
    mask: '999 999 999'
  },
  {
    name: 'Solomon Islands',
    code: 'SB',
    dialCode: '+677',
    mask: '99 99999'
  },
  {
    name: 'Somalia',
    code: 'SO',
    dialCode: '+252',
    mask: '9 9999999'
  },
  {
    name: 'South Africa',
    code: 'ZA',
    dialCode: '+27',
    mask: '999 999 9999'
  },
  {
    name: 'South Sudan',
    code: 'SS',
    dialCode: '+211',
    mask: '9999 999 999'
  },
  {
    name: 'Spain',
    code: 'ES',
    dialCode: '+34',
    mask: '999 99 99 99'
  },
  {
    name: 'Sri Lanka',
    code: 'LK',
    dialCode: '+94',
    mask: '999 999 9999'
  },
  {
    name: 'Sudan',
    code: 'SD',
    dialCode: '+249',
    mask: '999 999 9999'
  },
  {
    name: 'Suriname',
    code: 'SR',
    dialCode: '+597',
    mask: '999-9999'
  },
  {
    name: 'Svalbard and Jan Mayen',
    code: 'SJ',
    dialCode: '+47',
    mask: '999 99 999'
  },
  {
    name: 'Swaziland',
    code: 'SZ',
    dialCode: '+268',
    mask: '9999 9999'
  },
  {
    name: 'Sweden',
    code: 'SE',
    dialCode: '+46',
    mask: '999-999 99 99'
  },
  {
    name: 'Switzerland',
    code: 'CH',
    dialCode: '+41',
    mask: '999 999 99 99'
  },
  {
    name: 'Syrian Arab Republic',
    code: 'SY',
    dialCode: '+963',
    mask: '9999 999 999'
  },
  {
    name: 'Taiwan',
    code: 'TW',
    dialCode: '+886',
    mask: '9999 999 999'
  },
  {
    name: 'Tajikistan',
    code: 'TJ',
    dialCode: '+992',
    mask: '999 99 9999'
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    code: 'TZ',
    dialCode: '+255',
    mask: '9999 999 999'
  },
  {
    name: 'Thailand',
    code: 'TH',
    dialCode: '+66',
    mask: '999 999 9999'
  },
  {
    name: 'Timor-Leste',
    code: 'TL',
    dialCode: '+670',
    mask: '9999 9999'
  },
  {
    name: 'Togo',
    code: 'TG',
    dialCode: '+228',
    mask: '99 99 99 99'
  },
  {
    name: 'Tokelau',
    code: 'TK',
    dialCode: '+690',
    mask: '9999'
  },
  {
    name: 'Tonga',
    code: 'TO',
    dialCode: '+676',
    mask: '999 9999'
  },
  {
    name: 'Trinidad and Tobago',
    code: 'TT',
    dialCode: '+1868',
    mask: '(999) 999-9999'
  },
  {
    name: 'Tunisia',
    code: 'TN',
    dialCode: '+216',
    mask: '99 999 999'
  },
  {
    name: 'Turkey',
    code: 'TR',
    dialCode: '+90',
    mask: '(999) 999 9999'
  },
  {
    name: 'Turkmenistan',
    code: 'TM',
    dialCode: '+993',
    mask: '9 99 999999'
  },
  {
    name: 'Turks and Caicos Islands',
    code: 'TC',
    dialCode: '+1649',
    mask: '(999) 999-9999'
  },
  {
    name: 'Tuvalu',
    code: 'TV',
    dialCode: '+688',
    mask: '999999'
  },
  {
    name: 'Uganda',
    code: 'UG',
    dialCode: '+256',
    mask: '9999 999999'
  },
  {
    name: 'Ukraine',
    code: 'UA',
    dialCode: '+380',
    mask: '999 999 9999'
  },
  {
    name: 'United Arab Emirates',
    code: 'AE',
    dialCode: '+971',
    mask: '999 999 9999'
  },
  {
    name: 'United Kingdom',
    code: 'GB',
    dialCode: '+44',
    mask: '99999 999999'
  },
  {
    name: 'United States',
    code: 'US',
    dialCode: '+1',
    mask: '(999) 999-9999'
  },
  {
    name: 'Uruguay',
    code: 'UY',
    dialCode: '+598',
    mask: '999 999 999'
  },
  {
    name: 'Uzbekistan',
    code: 'UZ',
    dialCode: '+998',
    mask: '9 99 999 99 99'
  },
  {
    name: 'Vanuatu',
    code: 'VU',
    dialCode: '+678',
    mask: '999 9999'
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    code: 'VE',
    dialCode: '+58',
    mask: '9999-9999999'
  },
  {
    name: 'Vietnam',
    code: 'VN',
    dialCode: '+84',
    mask: '999 999 99 99'
  },
  {
    name: 'Wallis and Futuna',
    code: 'WF',
    dialCode: '+681',
    mask: '99 99 99'
  },
  {
    name: 'Yemen',
    code: 'YE',
    dialCode: '+967',
    mask: '999 999 999'
  },
  {
    name: 'Zambia',
    code: 'ZM',
    dialCode: '+260',
    mask: '999 9999999'
  },
  {
    name: 'Zimbabwe',
    code: 'ZW',
    dialCode: '+263',
    mask: '999 999 9999'
  }
];

export default Countries;
